'use strict';

var centralApp = angular.module('app.services');
centralApp.factory('segmentosApi', segmentosSrv);
segmentosSrv.$inject = ['$resource', 'ConfigApp'];

function segmentosSrv($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/segmentos',
        {  }, {
            listarSegmentos: {
                method: 'GET',
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/segmentos/centrais_servico/' + ConfigApp.CentralServicoModuloId
            },
            lerDadosChamado: {
                method: 'GET',
                isArray: false,
                url: ConfigApp.UrlApi + '/v1.0/segmentos/dados_chamado/grupos_suporte/:grupoDeSuporteId/grupos_suporte_segmentos/:grupoDeSuporteSegmentoId'
            },
            listarSegmentosPorCanal: {
                method: 'GET',
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/segmentos/grupos_suporte/:grupoDeSuporteId/canais_atendimento/:canalDeAtendimentoId',
                ignoreLoadingBar: true
            }
        });
};



//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/services/segmentos-api-service.js
// module id = 330
// module chunks = 1